export const Module = Object.freeze({
	Booking: 'booking',
	Crm: 'crm',
});
